import { AlertCircle } from 'lucide-react';

// Case types that require a police report per business rule (MVA + Rideshare).
export const POLICE_REPORT_CASE_TYPES = ['auto_accident', 'rideshare_accident'];

export const requiresPoliceReport = (caseType) => POLICE_REPORT_CASE_TYPES.includes(caseType);

/**
 * PoliceReportNotice
 *
 * Prominent inline banner shown right under the Case Type selector. Non-blocking:
 * the client can still submit without uploading a police report. On the review /
 * submit step, pass `variant="reminder"` for a slightly lighter tone.
 *
 * @param {'notice'|'reminder'} variant
 * @param {boolean} hasPoliceReport  suppress the banner if the user already uploaded one
 */
const PoliceReportNotice = ({ variant = 'notice', hasPoliceReport = false }) => {
  if (hasPoliceReport) return null;
  const isReminder = variant === 'reminder';
  return (
    <div
      role="note"
      data-testid={`police-report-${variant}`}
      style={{
        marginTop: '0.75rem',
        padding: '0.85rem 1rem',
        borderRadius: 10,
        border: `1px solid ${isReminder ? '#fcd34d' : '#f59e0b'}`,
        background: isReminder ? '#fffbeb' : '#fff7ed',
        display: 'flex',
        gap: '0.65rem',
        alignItems: 'flex-start',
      }}
    >
      <AlertCircle size={18} style={{ color: '#b45309', flexShrink: 0, marginTop: '2px' }} />
      <div style={{ fontSize: '0.87rem', lineHeight: 1.55, color: 'var(--mcl-text-body)' }}>
        <strong style={{ display: 'block', marginBottom: '2px', color: '#92400e' }}>
          Police Report Required
        </strong>
        Because you selected <strong>Motor Vehicle Accident (MVA)</strong> or <strong>Ride Share</strong> as your case type, a copy of the police report is required. If you have it available, please upload it now. If you do not have it yet, you may still submit your application and provide it later. Uploading the police report as soon as possible will help funders review your application more quickly.
      </div>
    </div>
  );
};

export default PoliceReportNotice;
